import React from 'react'
import { format, isWithinInterval } from 'date-fns'
import { Heading } from 'react-bulma-components'

/** Minimal day slot for month delimiter (isoDate + month/day for comparison). */
export interface MonthDelimiterDay {
  isoDate: string
  month: number
  day: number
}

export interface MonthDelimiterProps {
  /** Calendar range start (YYYY-mm-dd). */
  startDate: string
  /** Week as 7 slots (nullable). */
  calendarWeek: (MonthDelimiterDay | null)[]
}

/**
 * Renders a "Month YYYY" row when the week is the first in range or crosses a month boundary.
 * No calendar context: parent passes startDate and calendarWeek.
 */
export const MonthDelimiter = ({ startDate, calendarWeek }: MonthDelimiterProps): JSX.Element => {
  const firstDay = calendarWeek.find((d): d is MonthDelimiterDay => d != null)
  const lastDay = calendarWeek[calendarWeek.length - 1]
  if (!firstDay) return <></>
  if (!lastDay) return <></>

  const isFirstCalendarWeek = isWithinInterval(new Date(startDate), {
    start: new Date(firstDay.isoDate),
    end: new Date(lastDay.isoDate),
  })
  const isNextMonth = firstDay.month !== lastDay.month || firstDay.day === 1

  if (isNextMonth || isFirstCalendarWeek)
    return (
      <tr>
        <td colSpan={8}>
          <Heading my={3} size={3}>
            {' '}
            {format(new Date(lastDay.isoDate), 'MMMM yyyy')}
          </Heading>
        </td>
      </tr>
    )
  return <></>
}
